import React, { useState } from 'react';

const ImageUpload = ({ image, onImageChange, id }) => {
  const [previewImage, setPreviewImage] = useState(image);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewImage(imageUrl);
      onImageChange(file); // Update parent state with the file
      event.target.value = ''; // Reset input to allow re-selection
    }
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    onImageChange(null); // Notify parent component about image removal
  };

  return (
    <div className="image-upload-container1" onChange={handleImageUpload}>
      <input
        id={`file-input-${id}`}
        type="file"
        accept="image/*"
        className="file-input1"
        
      />
      {previewImage ? (
        <div className="image-preview-container1">
          <img src={previewImage} alt="Uploaded preview" className="uploaded-image1" />
          <button
            className="remove-image-button1"
            onClick={handleRemoveImage}
            aria-label="Remove image"
          >
            X
          </button>
        </div>
      ) : (
        <div className="upload-placeholder1">Click or Drag to Upload</div>
      )}
    </div>
  );
};

export default ImageUpload;
